<div
        *ngFor="let n of visibleNotifications; let i = index"
        [style.top.%]="14 + i * 12"
        class="d-flex align-items-center justify-content-center flex-column position-fixed notification-banner"
>
    <button type="button" class="notification-close" (click)="dismissBanner(n)" aria-label="Dismiss notification">
        &times;
    </button>

    <!-- Icon + Message -->
    <div class="d-flex align-items-center text-center text-md-start mb-3">
        <span class="notification-icon"><i class="uil uil-megaphone"></i></span>
        <strong class="notification-message">{{ n.message }}</strong>
    </div>

    <!-- CTA -->
    <div class="d-flex justify-content-center align-items-center">
        <button class="notification-cta" *ngIf="n.targetURL" (click)="goToNotification(n)">
            Click here to register for the event <span aria-hidden="true">&rsaquo;</span>
        </button>
    </div>
</div>
